import { Table, Tag, Space, Button } from "antd";

import CheckIcon from "@/icons/CheckIcon";
import PencilIcon from "@/icons/PencilIcon";
import TrashIcon from "@/icons/TrashIcon";

import { TASK_TYPE_OPTIONS } from "@/constants/tasks";

const isSystemType = (item) => {
  if (!item) return false;
  return item.is_default || item.is_system;
};

const isCanBeDeleted = (item) => {
  if (!item) return false;
  return (item.can_be_deleted || item.can_be_marked_deleted) && !item.deleted;
};

const shouldDisableDelete = (item) => {
  return !item || isSystemType(item) || !isCanBeDeleted(item);
};

const getTypeIcon = (val) => {
  return TASK_TYPE_OPTIONS.find((option) => option.value === val)?.icon;
};

/**
 * Таблица типов задач с возможностью редактирования и удаления
 * @param {Array} data - Массив типов задач
 * @param {boolean} loading - Флаг загрузки
 * @param {Object} pagination - Настройки пагинации
 * @param {Function} onChange - Обработчик изменений таблицы
 * @param {Function} onEditItem - Обработчик редактирования типа задачи
 * @param {Function} onDeleteItem - Обработчик удаления типа задачи
 */
const TaskTypesTable = ({
  data,
  loading,
  pagination,
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const columns = [
    {
      title: "№ п/п",
      dataIndex: "idx",
      key: "idx",
      width: 90,
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.idx - b.idx,
        multiple: 1,
      },
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 2,
      },
      render: (_, { name, style_key }) => (
        <Tag icon={getTypeIcon(style_key)} className="tag-with-icon lg">
          {name}
        </Tag>
      ),
    },
    {
      title: "Основной",
      dataIndex: "is_default",
      key: "is_default",
      align: "center",
      render: (_, item) =>
        isSystemType(item) ? <CheckIcon style={{ fontSize: 16 }} /> : null,
    },
    {
      title: "Удален",
      dataIndex: "deleted",
      key: "deleted",
      align: "center",
      render: (deleted) =>
        deleted ? <CheckIcon style={{ fontSize: 16 }} /> : "",
    },
    {
      title: "",
      width: 90,
      fixed: "right",
      align: "center",
      key: "actions",
      render: (_, item) => (
        <Space>
          <Button
            type="link"
            icon={<PencilIcon />}
            onClick={() => onEditItem(item)}
            aria-label="Редактировать тип задачи"
          />
          <Button
            type="link"
            icon={<TrashIcon />}
            disabled={shouldDisableDelete(item)}
            onClick={() => onDeleteItem(item)}
            aria-label="Удалить тип задачи"
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default TaskTypesTable;
